import { getTheme } from './service';

let rootComponent;

function setRootComponent(component) {
  rootComponent = component;
}

function onHealthRowClick(healthType) {
  if (rootComponent.state.filterHealth === healthType || healthType === 'all') {
    rootComponent.setState({ filterHealth: null });
  } else {
    rootComponent.setState({ filterHealth: healthType });
  }
}

async function updateTheme(customerCode, generation) {
  if (!rootComponent) {
    return;
  }

  if (generation !== undefined) {
    rootComponent._themeGeneration = generation;
  }

  try {
    const { logoUrl, name, customerCode: resolvedCustomerCode } = await getTheme(customerCode);
    if (generation !== undefined && generation !== rootComponent._themeGeneration) {
      return;
    }
    rootComponent.setState({
      logoUrl: logoUrl || null,
      customerName: name || null,
      logoLoadFailed: false,
      activeCustomerCode: resolvedCustomerCode,
    });
  } catch (error) {
    console.error('Failed to load FASE theme', error);
  }
}

export { setRootComponent, onHealthRowClick, updateTheme };
